import axios from 'axios';

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL ||
    (process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:8000')).replace(/\/+$/, '');
const API_URL = `${BACKEND_URL}/api/`;
const URL = `${BACKEND_URL}/`;

export const axiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true, // Importante para permitir cookies HttpOnly
});

// Instancia para rutas fuera de /api/ (ej: /admin/)
export const rootInstance = axios.create({
    baseURL: URL,
    withCredentials: true,
});

// Tokens stay in HttpOnly cookies. Only the CSRF proof is kept in memory.
const csrfInstance = axios.create({baseURL: API_URL, withCredentials: true});
let csrfPending: Promise<string> | null = null;
const csrfToken = async (): Promise<string> => {
    if (!csrfPending) {
        csrfPending = csrfInstance.get<{csrfToken: string}>('csrf/')
            .then(response => response.data.csrfToken)
            .finally(() => {csrfPending = null;});
    }
    return csrfPending;
};
for (const instance of [axiosInstance, rootInstance]) {
    instance.interceptors.request.use(async config => {
        if (!['get', 'head', 'options'].includes((config.method || 'get').toLowerCase())) {
            config.headers.set('X-CSRFToken', await csrfToken());
        }
        return config;
    });
}

export default axiosInstance;

